import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from "react-bootstrap/Modal";
import { InfoHover } from "../InfoHover/InfoHover";
import { Accordion, Col, Row, Table } from "react-bootstrap";
import { useAuth0 } from '@auth0/auth0-react';
import { config } from "../../config";
import { ecsRequest } from "../../utils/apiClient";


export const TradingZoneModal = ({
    isNewTradingZone,
    showModal,
    setShowModal,
    handleTradingZone,
    existingTradingZone,
    tradeConfig,
    connections,
    userId,
}) => {
    const blankTradingZone = {
        min: 0,
        max: 0,
        startTime: '09:30',
        endTime: '12:00',
        label: '',
        displayText: '',
        ticker: '',
        type: '',
        zoneType: '',
        id: new Date().getTime() + Math.random() * 1000,
    };

    const [tradingZones, setTradingZones] = useState(isNewTradingZone ? [blankTradingZone] : [existingTradingZone]);
    const [groupList, setGroupList] = useState([]);
    const [automatedTradingZones, setAutomatedTradingZones] = useState([]);
    const [filterTicker, setFilterTicker] = useState('all');
    const { getAccessTokenSilently } = useAuth0();

    const getAllAutomatedTradingZones = async () => {
        let automatedZones = [];
        const token = await getAccessTokenSilently();
        const headers = {
            'Authorization': `Bearer ${token}`,
        };
        for (const ticker of config.supportedTickers) {
            const params = {
                uid: userId,
                ticker: ticker,
            };
            try {
                const zones = await ecsRequest('get', '/algo/zones', { headers, params });
                if (zones && zones.data && zones.data.length) {
                    for (const zone of zones.data) {
                        zone.ticker = ticker;
                    }
                    automatedZones = automatedZones.concat(zones.data);
                }
            } catch (error) {
                console.log('Could not get automated zones', error)
            }
        }
        setAutomatedTradingZones(automatedZones);
    }


    useEffect(() => {
        //Populate group list on screen load
        const groups = [];
        if (tradeConfig && connections && groups.length === 0) {
            for (const buid in connections) {
                if (tradeConfig[buid] && tradeConfig[buid].accountGroups.length) {
                    for (const group of tradeConfig[buid].accountGroups) {
                        let isCopiedToGroup = false;
                        if (
                            group.tradingZones &&
                            group.tradingZones.length &&
                            group.tradingZones.filter((zone) =>
                                zone.id === tradingZones[0].id
                            ).length
                        ) {
                            isCopiedToGroup = true;
                        }
                        groups.push({
                            connection: connections[buid].name,
                            groupName: group.groupName,
                            buid: buid,
                            isCopiedToGroup: isCopiedToGroup,
                        });
                    }
                }
            }
        }
        setGroupList(groups);
        if (!automatedTradingZones || automatedTradingZones.length === 0) {
            getAllAutomatedTradingZones();
        }

        // if (!isNewTradingZone) {
        //     getAutomatedTradingZones(existingTradingZone.ticker);
        // }
    }, [tradeConfig]);

    const handleAddTradingZone = () => {
        const zones = [...tradingZones];
        zones.push(blankTradingZone);
        setTradingZones(zones);
    };

    const handleFilterTicker = (e) => {
        setFilterTicker(e.target.value);
    };

    const handleRemoveTradingZone = (zoneIndex) => {
        const zones = [...tradingZones];
        const tradingZone = zones[zoneIndex];
        //Toggle off the auto zones toggle if it came from an auto-zone
        const autoZones = [...automatedTradingZones];
        const autoZoneIndex = autoZones.findIndex((zone) =>
            zone.ticker === tradingZone.ticker &&
            zone.zoneType === tradingZone.zoneType &&
            zone.displayText === tradingZone.displayText
        )
        if (autoZoneIndex >= 0) {
            autoZones[autoZoneIndex].isSelected = false;
            setAutomatedTradingZones(autoZones);
        }
        if (tradingZones.length > 1) {
            zones.splice(zoneIndex, 1);
        } else {
            zones[0] = blankTradingZone;
        }
        setTradingZones(zones);
    };

    const handleTradingZoneChange = (e, zoneIndex) => {
        const { name, value } = e.target;
        setTradingZones(prevZones => {
            const newZones = prevZones.map((zone, idx) => {
                if (idx === zoneIndex) {
                    if (name.startsWith('type-')) {
                        return { ...zone, ['type']: value };
                    } else {
                        return { ...zone, [name]: value };
                    }
                }
                return zone;
            });
            return newZones;
        });
    };

    const handleSelectZone = (e, zone) => {
        const autoZones = [...automatedTradingZones];
        const zoneIndex = autoZones.findIndex((autoZone) =>
            autoZone.ticker === zone.ticker &&
            autoZone.displayText === zone.displayText &&
            autoZone.zoneType === zone.zoneType
        );
        autoZones[zoneIndex].isSelected = e.target.checked;
        const zones = [...tradingZones];
        const chosenZone = autoZones[zoneIndex];

        if (e.target.checked) {
            const newZone = {
                id: new Date().getTime() + Math.random() * 1000,
                min: chosenZone.min,
                max: chosenZone.max,
                ticker: chosenZone.ticker,
                type: chosenZone.type,
                zoneType: chosenZone.zoneType,
                displayText: chosenZone.displayText,
                startTime: blankTradingZone.startTime,
                endTime: blankTradingZone.endTime,
                label: blankTradingZone.label,
            };

            if (
                zones.length <= 1 &&
                zones[0] &&
                zones[0].min === blankTradingZone.min && //If they didn't change the initial blank zone
                zones[0].max === blankTradingZone.max
            ) {
                //Remove the first unused zone
                zones[0] = newZone;
            } else {
                zones.push(newZone);
            }
        } else {
            const index = zones.findIndex((zone) =>
                zone.ticker === chosenZone.ticker &&
                zone.zoneType === chosenZone.zoneType &&
                zone.displayText === chosenZone.displayText
            )
            if (index >= 0) {
                zones.splice(index, 1);
            }
        }
        setTradingZones(zones);
        setAutomatedTradingZones(autoZones);
    };

    // const handleTradingZoneTickerChange = (e, zoneIndex) => {
    //     const zones = tradingZones;
    //     zones[zoneIndex][e.target.name] = e.target.value;
    //     setTradingZones(zones);
    //     //getAutomatedTradingZones(e.target.value)
    // };

    const handleCopyZone = (e, buid, groupName) => {
        const groups = JSON.parse(JSON.stringify(groupList));
        if (groups.length) {
            const index = groups.findIndex((g) => g.buid === buid && g.groupName === groupName);
            if (index >= 0) {
                groups[index].isCopiedToGroup = e.target.checked;
            }
        }
        setGroupList(groups);
    }

    const handleClose = () => setShowModal(false);

    const GroupList = ({ groups }) => {
        if (groups.length) {
            return (
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Connection</th>
                            <th>Group</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            groups
                                .map((group) => {
                                    return (
                                        <tr key={group.connection + group.groupName}>
                                            <td>{group.connection}</td>
                                            <td>
                                                <Form.Check
                                                    type="switch"
                                                    id={group.connection + group.groupName}
                                                    name={group.groupName}
                                                    label={group.groupName}
                                                    checked={group.isCopiedToGroup}
                                                    onChange={(e) => handleCopyZone(e, group.buid, group.groupName)}
                                                    value={group.isCopiedToGroup}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })
                        }
                    </tbody>
                </Table>
            )
        }
    };

    return (
        <Modal
            root={document.body}
            size="xl"
            show={showModal}
            onHide={handleClose}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {InfoHover(
                        isNewTradingZone ? 'Add Supply or Demand Zones' : 'Edit a Supply or Demand Zone',
                        "You can set custom trading zones to control the price ranges that the strategies you subscribe to will execute trades. If any custom trading zones are set, it will override any automated trading zones."
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="pb-3 mb-3 border-bottom">
                    <Col>
                        {
                            (isNewTradingZone) &&
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <Form.Label>
                                            <strong>{InfoHover(
                                                "Select Common Zones",
                                                "You can optionally choose from a list of common supply and demand zones to populate the zone values for you. You can still change the values even if you select a common zone."
                                            )}</strong>
                                        </Form.Label>
                                    </Accordion.Header>
                                    {
                                        (automatedTradingZones.length > 0) &&
                                        <Accordion.Body>
                                            <Row className="mb-3">
                                                <Col>
                                                    <Form.Select
                                                        onChange={(e) => handleFilterTicker(e)}
                                                        value={filterTicker ?? 'all'}
                                                        name="filterTicker"
                                                    >
                                                        <option key="all" value="all">All Tickers</option>
                                                        <option key="ES" value="ES">ES</option>
                                                        <option key="MES" value="MES">MES</option>
                                                        <option key="MNQ" value="MNQ">MNQ</option>
                                                        <option key="GC" value="GC">GC</option>
                                                        <option key="MGC" value="MGC">MGC</option>
                                                        <option key="MYM" value="MYM">MYM</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col />
                                                <Col />
                                            </Row>
                                            {
                                                automatedTradingZones
                                                    .filter((zone) =>
                                                        filterTicker === 'all' ||
                                                        zone.ticker === filterTicker
                                                    )
                                                    .map((zone, index) => (
                                                        <Form.Check
                                                            type="switch"
                                                            key={`${zone.ticker}-${zone.displayText}-${zone.zoneType}`}
                                                            id={`${zone.ticker}-${zone.displayText}-${zone.zoneType}`}
                                                            name={`${zone.ticker} - ${zone.displayText}`}
                                                            label={`${zone.ticker} - ${zone.displayText}`}
                                                            checked={zone?.isSelected ?? false}
                                                            onChange={(e) => handleSelectZone(e, zone)}
                                                            value={`${zone.ticker} - ${zone.displayText}`}
                                                        />
                                                    ))
                                            }
                                        </Accordion.Body>
                                    }
                                </Accordion.Item>
                            </Accordion>
                        }
                    </Col>
                </Row>
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={handleAddTradingZone}
                    hidden={!isNewTradingZone}
                >
                    Add Custom Zone
                </Button>
                <Form.Group className="mb-3 mt-3 pb-3 border-bottom" controlId="tradingZones">
                    <Accordion alwaysOpen>
                        {tradingZones.map((tradingZone, index) => {
                            return (
                                <Accordion.Item eventKey={tradingZone.id} key={tradingZone.id}>
                                    <Accordion.Header>
                                        <Form.Label>
                                            <strong>{tradingZone.ticker && tradingZone.displayText ? `${tradingZone.ticker} - ${tradingZone.displayText}` : 'Custom Zone'}</strong>
                                        </Form.Label>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row
                                            className="mt-3 mb-3 pb-3 border-bottom border-top"
                                            style={{ backgroundColor: 'rgb(128 128 128 / 3%)' }}
                                            key={tradingZone.id}
                                        >
                                            <Col>
                                                <Form.Label className="pt-2">
                                                    <strong>Ticker</strong>
                                                </Form.Label>
                                                <Form.Select
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                    value={tradingZone?.ticker ?? ''}
                                                    name="ticker"
                                                >
                                                    <option>Select ticker</option>
                                                    <option key="ES" value="ES">ES</option>
                                                    <option key="MES" value="MES">MES</option>
                                                    <option key="MNQ" value="MNQ">MNQ</option>
                                                    <option key="GC" value="GC">GC</option>
                                                    <option key="MGC" value="MGC">MGC</option>
                                                    <option key="MYM" value="MYM">MYM</option>
                                                </Form.Select>
                                                <Form.Label className="pt-2">
                                                    <strong>Start Time (Eastern Time)</strong>
                                                </Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    placeholder="Start time for the zone"
                                                    value={tradingZone?.startTime ?? ''}
                                                    name="startTime"
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                    required
                                                />
                                                <Form.Label className="pt-2">
                                                    <strong>End Time (Eastern Time)</strong>
                                                </Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    placeholder="End time for the zone"
                                                    value={tradingZone?.endTime ?? ''}
                                                    name="endTime"
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                    required
                                                />
                                            </Col>
                                            <Col>
                                                <Form.Label className="pt-2">
                                                    <strong>Common Zone</strong>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Label of the common zone"
                                                    value={tradingZone?.displayText ?? ''}
                                                    name="displayText"
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                />
                                                <Form.Label className="pt-2">
                                                    <strong>{InfoHover(
                                                        "Zone Type",
                                                        "Choose supply for bearish trading zones and demand for bullish trading zones."
                                                    )}</strong>
                                                </Form.Label>
                                                <Form.Check
                                                    type="radio"
                                                    label="Supply"
                                                    key="supply"
                                                    name={`type-${index}`}
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                    value="supply"
                                                    checked={tradingZone?.type === 'supply'}
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="Demand"
                                                    key="demand"
                                                    name={`type-${index}`}
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                    value="demand"
                                                    checked={tradingZone?.type === 'demand'}
                                                />
                                            </Col>
                                            <Col>
                                                <Form.Label className="pt-2">
                                                    <strong>Minimum Price</strong>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Minimum Zone Price"
                                                    value={tradingZone?.min ?? 0}
                                                    name="min"
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                    required
                                                />
                                                <Form.Label className="pt-2">
                                                    <strong>Maximum Price</strong>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Maximum Zone Price"
                                                    value={tradingZone?.max ?? 0}
                                                    name="max"
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                    required
                                                />
                                                <Form.Label className="pt-2">
                                                    <strong>Label</strong>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Optional text to identify the zone"
                                                    value={tradingZone?.label ?? ''}
                                                    name="label"
                                                    onChange={(e) => handleTradingZoneChange(e, index)}
                                                />
                                                {
                                                    tradingZones.length > 1 &&
                                                    <Button
                                                        className="mt-3"
                                                        size="sm"
                                                        variant="outline-danger"
                                                        onClick={() => handleRemoveTradingZone(index)}
                                                    >
                                                        Remove Zone
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        })}
                    </Accordion>
                </Form.Group>
                <Form className="pb-3">

                    <div className="border-bottom mb-3 pb-3">
                        <Form.Label className="pt-2">
                            <strong>{InfoHover(
                                "Apply Zone to Groups",
                                "Toggle on the groups you want to copy the zone to."
                            )}
                            </strong>
                        </Form.Label>
                        <GroupList
                            groups={groupList}
                        />
                    </div>

                    <div className="d-flex justify-content-center">
                        <Button
                            variant="primary"
                            onClick={() => handleTradingZone(tradingZones, groupList)}>
                            Save Trading Zone
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}